import React, { useEffect, useState } from 'react';

import { roleDisplayValueMap } from '../../../../util/RoleUtil';

import { Table } from '../../../common/table/Table';
import { SelectableTable } from '../../../common/table/SelectableTable';
import { SaveButton } from '../../../common/button/save-button/SaveButton';

export const StaffEditAssignments = ({ closeModal, setAssignedStaff, assignedStaff, availableStaff }) => {
  const [siteStaffRoleVOs, setSiteStaffRoleVOs] = useState([]);
  const [staffTableData, setStaffTableData] = useState([]);
  const [staffTableHeader, setStaffTableHeader] = useState('');
  const [selectedStaff, setSelectedStaff] = useState('');

  useEffect(() => {
    setSelectedStaff(availableStaff);
    setSiteStaffRoleVOs(availableStaff);
    handleViewRoleClick(availableStaff[0]);
  }, [availableStaff]);

  const handleViewRoleClick = (role) => {
    if (role && role.viewSiteStaffVOS && role.viewSiteStaffVOS.length > 0) {
      setStaffTableData(role.viewSiteStaffVOS);
      setStaffTableHeader('Staff: ' + (roleDisplayValueMap.get(role.roleName) ?? role.roleName));
    } else {
      setStaffTableData([]);
      setStaffTableHeader('');
    }
  };

  const handleSaveChangesClick = () => {
    const staffChangesToSave = selectedStaff.flatMap((role) => {
      if (role.viewSiteStaffVOS) {
        return role.viewSiteStaffVOS
          .filter((user) => user.selected)
          .map((user) => ({
            ...user,
            studyRole: role.roleName,
          }));
      }
      return [];
    });
    setAssignedStaff(staffChangesToSave);
    closeModal();
  };

  const handleCancelClick = () => {
    setSelectedStaff(siteStaffRoleVOs);
    closeModal();
  };

  const handleSelectedStaffChange = (selectedForms) => {
    setSelectedStaff((prevAssignedStaff) => {
      let updatedAssignedStaff = [...prevAssignedStaff];

      selectedForms.forEach((selectedUser) => {
        const { username, studyRole, selected } = selectedUser;

        const userIndex = updatedAssignedStaff.findIndex(
          (user) => user.username === username && user.studyRole === studyRole
        );

        if (userIndex !== -1) {
          if (!selected) {
            updatedAssignedStaff.splice(userIndex, 1);
          }
        } else {
          if (selected) {
            updatedAssignedStaff.push(selectedUser);
          }
        }
      });
      return updatedAssignedStaff;
    });
  };

  return (
    <div>
      <div className="form-section-site">
        <div className="staff-sections">
          <Table
            tableData={siteStaffRoleVOs.map((role) => ({
              ...role,
              role: roleDisplayValueMap.get(role.roleName) ?? role.roleName,
            }))}
            hiddenColumns={['viewSiteStaffVOS', 'roleName']}
            searchEnabled={true}
            filterEnabled={false}
            onRowClick={handleViewRoleClick}
            tableTitle={'Role Assignment'}
            maxRowCount={7}
            actionColumnEnabled={true}
            actionTwoClick={handleViewRoleClick}
            applyStyleChange={true}
          />
        </div>
        <div className="staff-sections">
          <SelectableTable
            tableData={staffTableData}
            hiddenColumns={[
              'personExternalReference',
              'selected',
              'first',
              'lastName',
              'username',
              'email',
              'studyRole',
            ]}
            searchEnabled={true}
            filterEnabled={false}
            tableTitle={staffTableHeader}
            buttonDisabled={true}
            maxRowCount={7}
            onSelectedFormsChange={handleSelectedStaffChange}
            selectedForms={assignedStaff}
            customHeaderName={'Assigned'}
          />
        </div>
      </div>
      <div className="staff-assignment-button-container">
        <SaveButton
          color={'#ffffff'}
          textColor="#6F8695"
          border="1px solid #6F8695"
          title={'Cancel'}
          onClick={handleCancelClick}
        />
        <SaveButton color={'#6F8695'} title={'Done'} onClick={handleSaveChangesClick} />
      </div>
    </div>
  );
};
